import { isMcpRole } from '../../../../Components/Permissions';
import { CareStatus, PaymentSource, ProviderServiceBlockedReason, Role } from '../../../../graphQL';
import { paymentSourceCopy } from '../../copy';

export const NONE_OPTION_ID = -1;
export const REQUIRED_MESSAGE = 'This field is required.';
export const LABEL_SIZE = 'f6';

export const providersBlockedReasonToLabel: Record<ProviderServiceBlockedReason, string> = {
  [ProviderServiceBlockedReason.PatientMissingGeoState]: 'Patient is missing a primary address',
};

export const paymentSourceOptions: { label: string; id: PaymentSource }[] = (
  Object.keys(paymentSourceCopy) as Array<PaymentSource>
).map(k => ({
  id: k,
  label: paymentSourceCopy[k],
}));

export const careStatusOptions: { label: string; id: CareStatus | null }[] = [
  { label: 'Active', id: CareStatus.Active },
  { label: 'Cancelled', id: CareStatus.Cancelled },
  { label: 'Screened Out', id: CareStatus.ScreenedOut },
  { label: 'Discharged', id: CareStatus.Discharged },
  { label: 'On Hold', id: CareStatus.OnHold },
  { label: 'N/A', id: null },
];

export const isStudentCareFlowEditable = (providerRole: Role, careStatus?: CareStatus): boolean => {
  // if N/A, editable
  if (!careStatus) {
    return true;
  }

  // if mcp and not active, not cancelled, or not onhold -> not editable
  if (isMcpRole(providerRole) && isCareStatusNotEditable(careStatus)) {
    return false;
  }

  return true;
};

export const isCareStatusNotEditable = (careStatus?: CareStatus): boolean => {
  return (
    careStatus !== CareStatus.Active &&
    careStatus !== CareStatus.Cancelled &&
    careStatus !== CareStatus.OnHold
  );
};
